import {api} from '../../system/api';

export default {
	getSetting: () => api.get('settings'),
	getDetailSetting: () => api.get('settings/general-detail'),
	updateSetting: (params) => api.post('settings/general', params, {headers: {'content-type': 'application/x-www-form-urlencoded'}}),
};
